import { useShop } from "@src/contexts/ShopProvider";
import {
  AvatarGridItem,
  GameModeGridItem,
  VipPassGridItem,
  PodiumGridItem,
} from "../ShopGrid";
import { ShopItemType, StoreSkuItem } from "@playroomkit/pr-wars-data";
import { BundleGridItem } from "../ShopGrid/BundleGridItem";

interface ShopItemProps {
  item: StoreSkuItem;
  showPrice: (price: number | string) => string;
}

export const ShopItemMapper = ({ item, showPrice }: ShopItemProps) => {
  const { handleClick } = useShop();
  const { key, ...rest } = item;

  switch (item.metadata?.type) {
    case ShopItemType.AVATAR: {
      return (
        <AvatarGridItem
          key={key}
          {...rest}
          showPrice={showPrice}
          onClick={handleClick}
        />
      );
    }
    case ShopItemType.GAME_MODE: {
      return (
        <GameModeGridItem
          key={key}
          {...rest}
          showPrice={showPrice}
          onClick={handleClick}
        />
      );
    }
    case ShopItemType.VIP_PASS: {
      return (
        <VipPassGridItem
          key={key}
          {...rest}
          showPrice={showPrice}
          onClick={handleClick}
        />
      );
    }
    case ShopItemType.BOT: {
      return (
        <AvatarGridItem
          key={key}
          {...rest}
          showPrice={showPrice}
          onClick={handleClick}
        />
      );
    }
    case ShopItemType.BUNDLE: {
      return (
        <BundleGridItem
          key={key}
          {...rest}
          showPrice={showPrice}
          onClick={handleClick}
        />
      );
    }
    case ShopItemType.PODIUM: {
      return (
        <PodiumGridItem
          key={key}
          {...rest}
          showPrice={showPrice}
          onClick={handleClick}
        />
      );
    }
  }

  return null;
};
